<template>
    <div>
        <div class="ibox">
            <p class="p-0-18" style="margin-top: 15px">
                <span class="products-title">Products</span>
                <span class="float-right">
                    <a href="javascript:;"  class="add-icon" data-toggle="modal"
                       @click="show_all_product_in_popup"   :data-target="`#${modalId}`">
                        <svg width="20" style="fill: #03A9F4;" height="20" viewBox="0 0 20 20" fill="none"
                             xmlns="http://www.w3.org/2000/svg"> <path
                            d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                            fill="#03A9F4"/>
                        </svg>
                    </a>
                </span>
                <span class="select-services-dropdown-add-label float-right"
                      data-toggle="modal"
                      @click="show_all_product_in_popup"
                      :data-target="`#${modalId}`">
                    Add
                </span>
            </p>
        </div>

        <products :currency="currency" v-model="products" :service="service"></products>

        <custom-products :currency="currency" v-model="customProducts" :service="service"></custom-products>

        <add-product-modal :id="modalId" :service="service" :auto-assigned="autoAssigned" :service-booking-products="serviceBookingProducts"></add-product-modal>
        <input type="hidden" :id="totalId" :name="totalId">
    </div>
</template>

<script>
import Products from "./Products.vue";
import AddProductModal from "./AddProductModal.vue";
import ConfirmationPopup from "../../../common/components/ConfirmationPopup.vue";
import CustomProducts from "./customProducts.vue";
import {EventBus} from "@/events/event-bus";

export default {
    name: "AddProduct",
    components: {CustomProducts, ConfirmationPopup, AddProductModal, Products},
    props: {
        value: {
            type: Array,
            required: true
        },
        service: {
            required: true,
            type: Object,
        },
        currency: {
            type: Object,
            required: true
        },
        autoAssigned:{
            type: Array,
            default:[]
        },
        serviceBookingProducts:{
            type: Array,
            default:[]
        }
    },
    data() {
        return {
            customProducts: [],
            products: [],
        }
    },
    computed: {

        id() {
            if (parseInt(this.clone)) {
                return `products_div_${this.service.service_id}_${this.service.clone}`;
            }

            return `products_div_${this.service.service_id}`;
        },
        totalId() {
            if (parseInt(this.clone)) {
                return `products_total_${this.service.service_id}_${this.service.clone}`;
            }
            return `products_total_${this.service.service_id}`;
        },
        modalId() {
             if (parseInt(this.service.clone)) {

                return `add-product-modal-popup_${this.service.service_id}_${this.service.clone}`;
            }

            return `add-product-modal-popup_${this.service.service_id}`;
        },
        allProducts() {
            return [...this.products, ...this.customProducts]
        }
    },
    created() {
    },
    methods: {

        show_all_product_in_popup() {
             EventBus.$emit('show_all_product_in_popup',1)
        },

    },
    watch: {
        allProducts: {
            handler(value) {
                this.$emit('input', value)
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>